import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import OwnServices from '../sections/OwnServices'
import Seo from '../components/Seo'
import { sizes } from '../utils/breakpoints'

const Servicios = () => {
  const { t } = useTranslation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.servicios.title')}
        description={t('seo.servicios.description')}
        path="/servicios"
      />
      <OwnServices />
    </Container>
  )
}

export default Servicios

const Container = styled.div`
  padding-top: 110px;

  @media (max-width: ${sizes.mobile}px) {
    padding-top: 70px;
  }
`
